import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withSpinning from '../../../../elements/HOC/withSpinning'
import InfoTooltip from '../../../../elements/InfoTooltip'
import ProductSelectTree from '../../../../elements/ProductSelectTree'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import React, { Fragment, useEffect } from 'react'
import { Col, Form, Input, Radio, Row } from 'antd'
import { get, isEmpty } from 'lodash'
import { compose } from 'recompose'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import EmployeesSelect from '../../../../elements/Select/Employee/EmployeesSelect'
import { EnquiriesSelect } from '../../../../components/Sales/Quotes/AddQuote/AddQuote'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { EnquiriesApi } from '../../../../api/Sales/Enquiries'
import CustomSpin from '../../../../elements/CustomSpin'
import Authentication from '../../../../modules/Authentication'
import withData from '../../../../elements/Select/withData'
import FormItem from 'antd/es/form/FormItem'
import withSort from '../../../../elements/HOC/withSort'

const DWGTypeSelect = compose(
  withData({
    data: [
      { key: 'ID', value: 'ID - INFORMATION' },
      { key: 'SD', value: 'SD - SHOP' },
      { key: 'PD', value: 'PD - PRODUCTION' },
      { key: 'AD', value: 'AD - AS BUILT' },
      { key: 'IG', value: 'IG - INSTALLATION GUIDE' },
    ],
  }),
  withSort
)(CustomSelect)

const DWGDetailSelect = compose(
  withData({
    data: [
      { key: 'D01', value: 'D01 - LAYOUT' },
      { key: 'D02', value: 'D02 - ASSEMBLY' },
      { key: 'D03', value: 'D03 - PART DETAIL' },
      { key: 'D04', value: 'D04 - REBAR & CONCRETE DETAIL' },
      { key: 'D05', value: 'D05 - WATER SUPPLY SCHEMATIC LAYOUT' },
      { key: 'D06', value: 'D06 - SANITARY SCHEMATIC LAYOUT' },
      { key: 'D07', value: 'D07 - ELECTRICAL SCHEMATIC LAYOUT' },
      { key: 'D08', value: 'D08 - LIGHT WEIGHT STEEL DETAIL' },
      { key: 'D09', value: 'D09 - WALL DETAIL' },
    ],
  }),
  withSort
)(CustomSelect)

const { TextArea } = Input

const auth = new Authentication()

function DWGForm(props) {
  const { dwg, enquiryID, isNew } = props
  const { getFieldDecorator } = props.form

  const { getFieldValue, setFieldsValue, resetFields } = props.form

  const [SalesOrderSelect] = useFetchSelectUrl(
    {
      name: 'salesOrder',
      url: `enquiries/${(getFieldValue('enquiry._id') || '').replace('activities/', '')}/salesOrder`,
      cache: false,
    },
    [getFieldValue('enquiry._id')],
    isEmpty(getFieldValue('enquiry._id')),
    undefined,
    (enquiry) => ({
      ...enquiry,
      display: `${enquiry.code} - ${enquiry.title}`,
    })
  )

  const { fetching, object: enquiry } = useFetchObject(
    () => EnquiriesApi.read((getFieldValue('enquiry._id') || '').replace('activities/', '')),
    false,
    [getFieldValue('enquiry._id')],
    isEmpty(getFieldValue('enquiry._id')) || dwg._id
  )
  React.useEffect(() => {
    if (!isEmpty(enquiry) && !dwg._id)
      setFieldsValue({
        title: enquiry.title,
        'company._id': get(enquiry, 'company._id'),
      })
  }, [enquiry._rev])

  const FileSelectCmp = compose(
    withUrlFetch({
      name: `${dwg._id}_files`,
      url: `files/?folder=${dwg._id}`,
      forceFetch: true,
      dontFetch: isEmpty(dwg._id),
    }),
    withSpinning,
    withSort
  )(CustomSelect)

  const codeCompany = 'MSG'
  const codeVariant = getFieldValue('dwg.variant')
  const codeType = getFieldValue('dwg.type')
  const codeDetail = getFieldValue('dwg.detail')
  const codeSheet = getFieldValue('dwg.sheetNo')

  const isCodeReady =
    !isEmpty(codeCompany) && !isEmpty(codeVariant) && !isEmpty(codeDetail) && !isEmpty(codeSheet) && !isEmpty(codeType)

  const isCodeEditable = isNew || dwg.status === 'Draft'

  useEffect(() => {
    if (isCodeReady) {
      const code = [codeCompany, codeVariant, codeType, codeDetail, codeSheet].join('-') + '.00'
      isCodeEditable && setFieldsValue({ code })
    }
  }, [codeCompany, codeDetail, codeVariant, codeType, codeSheet])

  const isSale = getFieldValue('budget.budgetType') === 'Sales'

  console.log(isCodeEditable)
  return (
    <Form>
      <CustomSpin spinning={fetching}>
        <Row>
          {isCodeReady && isCodeEditable && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="DWG Code">
                {getFieldDecorator('code', {
                  initialValue: get(dwg, 'code'),
                  rules: rules.input,
                })(<Input disabled={!isCodeEditable} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Activity Type">
              {getFieldDecorator('budget.budgetType', {
                initialValue: get(dwg, 'budget.budgetType') ? 'Sales' : 'Internal',
              })(
                <Radio.Group>
                  <Radio.Button value="Internal">Internal</Radio.Button>
                  <Radio.Button value="Sales">Sales</Radio.Button>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        {isSale && (
          <Fragment>
            <FormSectionTitle title={'CLIENT DETAILS'} />
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Enquiry">
                  {getFieldDecorator('enquiry._id', {
                    initialValue: get(dwg, 'enquiry._id') || enquiryID,
                    rules: rules.select,
                  })(<EnquiriesSelect keyAtr={'_id'} valueAtr={'display'} placeholder={'Select an enquiry'} />)}
                </Form.Item>
              </Col>
              {!!getFieldValue('enquiry._id') && (
                <Col span={12}>
                  <Form.Item {...defaultFormItemLayout} label="Sales Order">
                    {getFieldDecorator('order._id', {
                      initialValue: get(dwg, 'order._id'),
                      //rules: rules.select,
                    })(<SalesOrderSelect keyAtr={'_id'} valueAtr={'display'} placeholder={'Select an Sales Order'} />)}
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Fragment>
        )}
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Company">
              {getFieldDecorator('company._id', {
                initialValue: get(dwg, 'company._id') || 'members/294426329241',
                rules: rules.select,
              })(<OrganisationsSelect />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Designer">
              {getFieldDecorator('companyRep._id', {
                initialValue: get(dwg, 'companyRep._id') || auth.getMember()._id,
                rules: rules.select,
              })(
                <EmployeesSelect placeholder="Received By" keyAtr={'_id'} valueAtr={'name'} style={{ width: '100%' }} />
              )}
            </Form.Item>
          </Col>
        </Row>

        <FormSectionTitle title={'DRAWING DETAILS'} />
        <Row>
          <Col span={12}>
            <FormItem {...defaultFormItemLayout} label="DWG Type">
              {getFieldDecorator('dwg.type', {
                initialValue: get(dwg, 'dwg.type') || 'ID',
                rules: rules.select,
              })(<DWGTypeSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem {...defaultFormItemLayout} label="DWG Detail">
              {getFieldDecorator('dwg.detail', {
                initialValue: get(dwg, 'dwg.detail'),
                rules: rules.select,
              })(<DWGDetailSelect />)}
            </FormItem>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Sheet No">
              {getFieldDecorator('dwg.sheetNo', {
                initialValue: get(dwg, 'dwg.sheetNo'),
                rules: rules.input,
              })(<Input style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Variant Code">
              {getFieldDecorator('dwg.variant', {
                initialValue: get(dwg, 'dwg.variant'),
                rules: rules.input,
              })(<Input style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="DWG Title">
              {getFieldDecorator('title', {
                initialValue: get(dwg, 'title'),
                rules: rules.input,
              })(<Input style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...defaultFormItemLayout}
              label={<InfoTooltip value={'Drawing PDF'} title={'If empty; please upload files in documents tab.'} />}>
              {getFieldDecorator('dwgFile', {
                initialValue: get(dwg, 'dwgFile'),
              })(<FileSelectCmp keyAtr="_id" valueAtr="name" placeholder={'Drawing PDF'} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Remarks">
              {getFieldDecorator('comment', {
                initialValue: get(dwg, 'comment'),
              })(<TextArea style={{ height: 100 }} />)}
            </Form.Item>
          </Col>
        </Row>
        {isSale && (
          <Fragment>
            <Row>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Client Code">
                  {getFieldDecorator('dwg.client.code', {
                    initialValue: get(dwg, 'dwg.client.code'),
                  })(<Input placeholder="Client DWG Code" style={{ width: '100%' }} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Revision">
                  {getFieldDecorator('dwg.client.revision', {
                    initialValue: get(dwg, 'dwg.client.revision'),
                  })(<Input placeholder="Client DWG Revision No" />)}
                </Form.Item>
              </Col>
            </Row>
          </Fragment>
        )}

        <FormSectionTitle title={'PRODUCT DETAILS'} />

        <ProductSelectTree
          doc={dwg}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
          }}
        />
      </CustomSpin>
    </Form>
  )
}

DWGForm.propTypes = {}
DWGForm.defaultProps = {}

export default Form.create()(DWGForm)
